import { Provider } from '@angular/core';
import { AuthRepository } from './repositories/auth.repository';
import { SupabaseAuthRepository } from './repositories/supabase-auth.repository';

export const provideAuth = (): Provider[] => [
  {
    provide: AuthRepository,
    useClass: SupabaseAuthRepository,
  },
];
